import axios from 'axios';
import {load} from 'recaptcha-v3'
import store from '../store'
import {SET_STATE_DATA} from "@/store/actions/se";

const env = [
  // {uiloc: ['localhost'], apiloc: 'http://localhost:8082/duiu', siteKey: ''},
  {uiloc: ['localhost'], apiloc: 'https://api-ecs.duiu.devl-du.aws.fanniemae.com/duiu', siteKey: ''},

  {uiloc: ['ui-ecs.duiu.devl-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.devl-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['devl.duiu.du.devl.intgfanniemae.com'], apiloc: 'https://devlapi.duiu.du.devl.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs.duiu.test-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.test-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['test.duiu.du.test.intgfanniemae.com'], apiloc: 'https://testapi.duiu.du.test.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs-alb.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-ecs-alb.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-01-ecs.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-01-ecs.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-02-ecs.duiu.acpt-du.aws.fanniemae.com'], apiloc: 'https://api-02-ecs.duiu.acpt-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['acpt.duiu.du.acpt.intgfanniemae.com'], apiloc: 'https://acptapi.duiu.du.acpt.intgfanniemae.com/duiu', siteKey: '', external: true},
  {uiloc: ['incomecalculator.acptfanniemae.com'], apiloc: 'https://acptapi.duiu.du.acpt.intgfanniemae.com/duiu', siteKey: '', external: true},

  {uiloc: ['ui-ecs.duiu.acnt-du.aws.fanniemae.com'], apiloc: 'https://api-ecs.duiu.acnt-du.aws.fanniemae.com/duiu', siteKey: ''},

  {uiloc: ['ui-ecs-alb.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-ecs-alb.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-01-ecs.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-01-ecs.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['ui-02-ecs.duiu.prod-du.aws.fanniemae.com'], apiloc: 'https://api-02-ecs.duiu.prod-du.aws.fanniemae.com/duiu', siteKey: ''},
  {uiloc: ['prod.duiu.du.prod.fanniemae.com'], apiloc: 'https://prodapi.duiu.du.prod.fanniemae.com/duiu', siteKey: '', external: true},
  {uiloc: ['incomecalculator.fanniemae.com'], apiloc: 'https://prodapi.duiu.du.prod.fanniemae.com/duiu', siteKey: '', external: true}
]


const setEnv = async () => {
  axios.defaults.baseURL = "localhost"
  for (let cfg of env) {
    if (hasMatchingUrl(cfg.uiloc)) {
      axios.defaults.baseURL = cfg.apiloc
      await store.commit(SET_STATE_DATA, {key: 'externalMode', value: !!cfg.external})

      await getRecaptchaKey(cfg)
      await load(cfg.siteKey)
      return
    }
  }
}

const hasMatchingUrl = (matchesArr) => {
  for (let host of matchesArr) {
    if (window.location.hostname.indexOf(host) >= 0) {
      return true
    }
  }
  return false
}

const getCaptchaSiteKey = () => {
  for (let cfg of env) {
    if (hasMatchingUrl(cfg.uiloc)) {
      return getRecaptchaKey(cfg)
    }
  }
  return undefined
}

const getRecaptchaKey = (cfg) => {
  if (cfg.siteKey) {
    return cfg.siteKey
  }

  return axios.get(`${cfg.apiloc}/config/gui`)
    .then( response => {
      cfg.siteKey = response.data?.recaptchaKey
    })
    .catch( ({response}) => {
    })
}

const saveRequest = (request) => {
    let preparedRequest = request;
    if (request.requestId && request.requestId.length > 0) {
      return axios.put(`request/${request.requestId}`, preparedRequest);
    } else {
      return axios.post('request', preparedRequest);
    }
}

const getRequest = (requestId, amount) => {
  // console.log('getRequest', requestId, amount)
    return axios.get(`request/${requestId}`,
      {
        params: {
          ...(store.state.se.externalMode ? {'amount': amount}: {})
        }
      });
}

const evaluate = (request) => {
  let preparedRequest = request;
  return axios.post('eval', preparedRequest);
}

const getPdfReport = (requestId, amount) => {
  return axios.get(`request/${requestId}/report`, {
    responseType: 'blob',
    headers: {'accept': 'application/pdf'},
    params: {
      ...(store.state.se.externalMode ? {'amount': amount}: {})
    }
  });
}

const createCaseFileAssociation = (caseFileId, requestId, zip, propertyZip, employmentStartDate, incomeAmount) => {
  incomeAmount = incomeAmount ?? null
  employmentStartDate = employmentStartDate ?? null
  let params = {
    'zip': zip
  }
  if (propertyZip) {
    params['property_zip'] = propertyZip
  }
  if (employmentStartDate) {
    params['start_date'] = employmentStartDate
  }
  if (incomeAmount) {
    params['income_amount'] = incomeAmount
  }

  return axios.post(`casefile/${caseFileId}/${requestId}`,
    {
      headers: {'Access-Control-Allow-Origin': '*'}
    },
    {
      params
  });
}

const removeCaseFileAssociation = (caseFileId, requestId) => {
  return axios.delete(`casefile/${caseFileId}/${requestId}`);
}

const getCaseFile = (duCaseFileId) => {
  return axios.get(`casefile/${duCaseFileId}`);
}

const checkConversationId = () => {
  return axios.get(`conversation`);
}

const getConfigGui = () => {
  return axios.get(`/config/gui`);
}

axios.interceptors.request.use(async (config) => {
    if (config.url.endsWith('config/gui')) {
      return config;
    }

    const recaptcha = await load(getCaptchaSiteKey())
    config.headers['x-fnma-recaptcha-token'] = await recaptcha.execute('api')

    if (store.state.se.conversationId) {
      config.headers['x-conversation-id'] = store.state.se.conversationId
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });


axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
 if (error.response.status === 403) {
    router.push('/forbidden-error')
  }
  return Promise.reject(error);
})

export default { setEnv, saveRequest, getRequest, evaluate, getPdfReport, createCaseFileAssociation,
  removeCaseFileAssociation, getCaseFile, checkConversationId, getRecaptchaKey, getConfigGui }
